import React, { useEffect, useState, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import io from "socket.io-client";
import bike from "../../../images/bike.png";
import bikeOffline from "../../../images/bikeOffline.png";
import { LatLng, LatLngBounds } from "leaflet";
import "leaflet/dist/leaflet.css";
import { CircularProgress } from "@mui/material";
import axios from "axios";
// import { Search } from "lucide-react";
import customerImage from "../../../images/customer.png";
// import toast from "react-hot-toast";
import Baseurl from "../../../Baseurl";
var socket = io.connect(Baseurl.baseurl, {
  transports: ["websocket"],
});
function TechnicianLocation({ customer, setOpen, id }) {
  var L = window.L;

  var bikePng = L.icon({
    iconUrl: bike,
    iconSize: [60, 40],
  });
  var bikePngOffline = L.icon({
    iconUrl: bikeOffline,
    iconSize: [60, 40],
  });

  const [riderDetails, setRiderDetails] = useState([]);
  const [vehicleSearch, setVehicleSearch] = useState([]);
  const [searchItem, setSearchItem] = useState("");
  const mapRef = useRef(null);
  const [bounds, setBounds] = useState([]);
  const [spinner, setSpinner] = useState(false);

  useEffect(() => {
    socket.on("admin-rider-lat-lng", (data) => {
      const newBounds = data.map(
        (coords) =>
          coords.RiderCurrentLat_Lng !== undefined &&
          new LatLng(
            coords.RiderCurrentLat_Lng.lat,
            coords.RiderCurrentLat_Lng.lng
          )
      );
      setBounds(newBounds);
      if (mapRef.current && newBounds.length > 0) {
        const leafletMap = mapRef.current;

        const leafletBounds = new LatLngBounds(newBounds);
        leafletMap.setView(
          leafletBounds.getCenter(),
          leafletMap.getBoundsZoom(leafletBounds)
        );
      }
      setRiderDetails(data);
      setVehicleSearch(data);
      setSpinner(false);
    });
  }, []);
  function getAllTechnician() {
    axios
      .get(Baseurl.baseurl + `/rider/get-all-rider-details`)
      .then((res) => {
        if (res.data.status) {
          setSpinner(false);
          const newBounds = res.data.data.map(
            (coords) =>
              coords.RiderCurrentLat_Lng !== undefined &&
              new LatLng(
                coords.RiderCurrentLat_Lng.lat,
                coords.RiderCurrentLat_Lng.lng
              )
          );
          if (customer !== undefined) {
            newBounds.push(new LatLng(customer.Lat, customer.Lon));
          }

          setBounds(newBounds);
          if (mapRef.current && newBounds.length > 0) {
            const leafletMap = mapRef.current;

            const leafletBounds = new LatLngBounds(newBounds);
            leafletMap.setView(
              leafletBounds.getCenter(),
              leafletMap.getBoundsZoom(leafletBounds)
            );
          }
          setRiderDetails(res.data.data);
          setVehicleSearch(res.data.data);
          setSpinner(false);
        }
      })
      .catch((err) => {});
  }
  useEffect(() => {
    getAllTechnician();
  }, []);

  function searchRiderByName(name) {
    let rider = [];
    if (vehicleSearch.length !== 0) {
      vehicleSearch.map((val) => {
        if (
          val.riderFirstName
            .toString()
            .toLowerCase()
            .includes(name.toLowerCase())
        ) {
          rider.push(val);
        }
      });
      let newBounds = rider.some(obj => obj.hasOwnProperty("RiderCurrentLat_Lng"))&&rider.map(
        (coords) =>
          coords.RiderCurrentLat_Lng !== undefined &&
          new LatLng(
            coords.RiderCurrentLat_Lng.lat,
            coords.RiderCurrentLat_Lng.lng
          )
      );
      setBounds(newBounds);
      if (mapRef.current && newBounds.length > 0) {
        const leafletMap = mapRef.current;

        const leafletBounds = new LatLngBounds(newBounds);
        leafletMap.setView(
          leafletBounds.getCenter(),
          leafletMap.getBoundsZoom(leafletBounds)
        );
      }
      setRiderDetails(rider);
    }
  }
  // function assignRiderToOrder(riderId) {

  //   axios
  //     .post(`${Baseurl.baseurl}/rider/assign-order/${riderId}/${id}`)
  //     .then((response) => {
  //       if (response.data.status) {
  //         toast.success(response.data.message);
  //       } else {
  //         toast.error(response.data.message);
  //       }
  //       setOpen(false)
  //     })
  //     .catch((err) => {});
  // }
  return (
    <div>
      {spinner ? (
        <div className="flex items-center justify-center h-[50vh]">
          <CircularProgress
            size={45}
            style={{
              color: "#1C485F",
            }}
          />
        </div>
      ) : (
        <>
          {/* <div className="row mb-3">
            <div className="col-sm-4">
              <input
                onWheel={(e) => e.target.blur()}
                type="number"
                className="form-control"
                placeholder="seacrh rider by Phone Number"
                onChange={(e) => searchRiderByName(e.target.value)}
              />
            </div>
          </div> */}
          <div>
            <div >
              <div >
                {/* <Search color="#9f9d9d" /> */}
              </div>
              <div className="py-1">
                <input
                  type="text"
                  className="form-control col-sm-4"
                  placeholder="Search here..."
                  onChange={(e) => searchRiderByName(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className=" w-full bg-white p-[20px] rounded-[22px] shadow-lg relative z-50">
            {bounds.length !== 0 && (
              <MapContainer
                ref={mapRef}
                style={{
                  height: "62vh",
                }}
                bounds={bounds}
                boundsOptions={bounds}
                scrollWheelZoom={true}
              >
                <TileLayer
                  url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                  maxZoom={21}
                  minZoom={4}
                  minZoomIsDrawing={18}
                  subdomains={["mt0", "mt1", "mt2", "mt3"]}
                />
                {riderDetails &&
                  riderDetails.map((val) => {
                    return (
                      <>
                        {val.RiderCurrentLat_Lng && (
                          <>
                            <Marker
                              icon={val.Online ? bikePng : bikePngOffline}
                              position={[
                                val.RiderCurrentLat_Lng.lat,
                                val.RiderCurrentLat_Lng.lng,
                              ]}
                            >
                              <Popup closeButton={false}>
                                <div className="flex gap-2 flex-col">
                                  <div className="flex items-center justify-center">
                                    <img
                                      style={{ border: "1px solid #d9d9d9" }}
                                      className="h-14 w-14 rounded-full"
                                      src={val.riderProfileImage}
                                      alt=""
                                    />
                                  </div>

                                  <div className="flex flex-col gap-2 items-start">
                                    <div className="text-gray-500 text-[12px] font-normal ">
                                      <span className="font-semibold">
                                        Name :
                                      </span>{" "}
                                      {val.riderFirstName} {val.riderLastName}
                                    </div>
                                    <div className="text-gray-500 text-[12px] font-normal ">
                                      <span className="font-semibold">
                                        Phone :
                                      </span>{" "}
                                      {val.riderPhone}
                                    </div>
                                    <div className="text-gray-500 text-[12px] font-normal ">
                                      <span className="font-semibold">
                                        Email :
                                      </span>{" "}
                                      {val.riderEmail}
                                    </div>
                                    <div className="flex justify-between w-full">
                                      <div>
                                        {val.Online ? (
                                          <div className=" px-[7.01px] py-[1.40px] bg-green-100 rounded-[2.80px] border border-green-300 justify-center items-center inline-flex">
                                            <div className="text-center text-green-800 text-[8.41px] font-medium  leading-3">
                                              Online
                                            </div>
                                          </div>
                                        ) : (
                                          <div className=" px-[7.01px] py-[1.40px] bg-red-100 rounded-[2.80px] border border-red-300 justify-center items-center inline-flex">
                                            <div className="text-center text-red-800 text-[8.41px] font-medium  leading-3">
                                              Offline
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                      {/* {customer!==undefined&&(
                                      <div onClick={()=>{
                                        assignRiderToOrder(val._id);
                                      }}  className="cursor-pointer px-[7.01px] py-[1.40px] bg-purple-100 rounded-[2.80px] border border-purple-300 justify-center items-center inline-flex">
                                        <div className="text-center text-purple-800 text-[8.41px] font-medium  leading-3">
                                          Re-Assign
                                        </div>
                                      </div>
                                      )} */}
                                    </div>
                                  </div>
                                </div>

                                <br />
                              </Popup>
                            </Marker>
                          </>
                        )}
                       
                      </>
                    );
                  })}
              </MapContainer>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default TechnicianLocation;
